import { helper } from "lib/helper";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input, // Import Input for the search functionality
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper"; // Import the filtering function
import * as XLSX from 'xlsx'; // Import XLSX for exporting to Excel
import ExportButton from "components/ExportButton";
import usersModel from "models/users.model";
import TableHeader from "components/TableHeader/TableHeader";
import { BACKGROUND_COLOR } from "constants/Constant";



const SupportPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [supportList, setSupportList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState(""); 

  const navigate = useNavigate();

  const getSupportList = async () => {
    try{
      const response = await usersModel.getSupport();
      setSupportList(response.support);
      console.log(response);
    }
    catch(err){
      console.log(err);
    }
  }


  useState(() => {
    getSupportList();
  },[])

  // Function to handle support deletion
  const handleDelete = (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this support issue?", "info", true)
      .then((result) => {
        const res = usersModel.deleteSupport(id).then((res) => {
          console.log("Support issue deleted:", res);
          getSupportList();
        }).catch((err) => {
          console.log(err);
        });
      });
  };

  // Empty update function for support issues
  const handleUpdate = (id) => {
    navigate('/admin/support/edit/' + id);
  };

  // Filter support issues based on the search query
  const filteredSupportList = filterItems( supportList.map(e => ({...e.user , ...e})), searchQuery, ['firstName', 'lastName' , 'mobileNo', 'subject', 'message', 'status']); 
  console.log(supportList);

  const columnsConfig = [
    { label: "S.No", getValue: (item, index) => ((currentPage - 1) * perPage) + index + 1 }, // Serial number
    { label: "Username (Mobile)", getValue: (item) => `${item?.user?.firstName} ${item?.user?.lastName} (${item?.user?.mobileNo})` }, // Username and Mobile
    { label: "Subject", getValue: (item) => item.subject }, // Subject
    { label: "Issue", getValue: (item) => item.message }, // Issue
    { label: "Status", getValue: (item) => item.status }, // Status
    { label: "User Type", getValue: (item) => item?.user?.type }, // User Type
  ];
  
 const options =  ['#' , 'Username (Mobile)', 'Subject', 'Issue', 'Status', 'User Type', 'Actions']


  return (
    <Container className="pt-7 " fluid style={{backgroundColor : BACKGROUND_COLOR}} >
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            {supportList.length === 0 ? (<Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">No Support Issues</h3>
              </CardHeader>
            </Card>) : (<Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">Support Issues</h3>
                  <div className="d-flex  -items-center">
                    <Input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: '200px', marginRight: '10px' }} 
                    />
                    <ExportButton data={supportList} columnsConfig={columnsConfig}/>
                  </div>
                </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <TableHeader options={options} />
                <tbody>
                  {filteredSupportList.slice((currentPage - 1) * perPage, currentPage * perPage).map((item, index) => {
                    return (
                      <tr key={item._id}>
                        <td>{((currentPage - 1) * perPage) + index + 1}</td>
                        <td>{item?.user?.firstName} {item?.user?.lastName} ({item?.user?.mobileNo})</td>
                        <td>{item?.subject}</td>
                        <td>{item?.message}</td>
                        <td>{item?.status}</td>
                        <td>{item?.user?.type}</td>
                        <td>
                          <Button
                            color="warning"
                            size="sm"
                            className="mr-2"
                            onClick={() => handleUpdate(item._id)}
                          >
                            <i class="fa-regular fa-pen-to-square"></i>
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(item._id)}
                          >
                            <i class="fa-solid fa-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredSupportList.length / perPage)} // Total number of pages based on filtered users
                  currentPage={currentPage}
                  pageUrl="/admin/support?"
                />
              </CardFooter>
            </Card>)}
          </div>
        </Row>
      )}
    </Container>
  );
};

export default SupportPage;
